<div class="flex items-center justify-between !p-5 !pb-0">
  <ng-content></ng-content>
  <div class="flex items-center">
    <button type="button" app-icon-button (click)="onClose()">
      <svg-icon class="h-7 w-7 select-none" src="assets/icons/icon-close-fine.svg"></svg-icon>
    </button>
  </div>
</div>
